import React from "react";
import { createStep } from "@whalecloud/page-builder-core/utils/elementUtils";
import StepsElement from "./components/StepsElement";
import StepsSetting from "./components/StepsSetting";
import { ReactComponent as PluginSvg } from "@assets/icons/tabs_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

const defaultSteps = [
  { title: 'Step 1', description: 'This is a description.', status: 'finish' },
  { title: 'Step 2', description: 'This is a description.', status: 'finish' },
  { title: 'Step 3', description: 'This is a description.', status: 'process'}
];

const getElements = () => {
  const elements = [];
  return elements;
}

export default () => {
  const messages = getLocale();
  return {
    name: 'steps',
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_STEP'], // 插件标题
    toolBarPreview: <PluginSvg />,
    data: {
      formItemSettings: {
        tabPosition: 'top',
        type: 'line',
        steps: defaultSteps
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_STEP']
      },
      settings: {
        margin: {
          mobile: { all: 0 },
          desktop: { all: 0 },
          advanced: true
        },
        padding: {
          mobile: { top: 15, left: 15, right: 15, bottom: 15 },
          desktop: { top: 0, left: 25, right: 25, bottom: 0 },
        },
        width: {
          value: "100%"
        },
      },
      events: [
        {
          "key": "ojvUqWKU3",
          "event": "onChange",
          "function": "onOk",
          "type": "pageJs"
        }
      ]
    },
    elements: getElements,
    pluginComponent: StepsElement,
    pluginSettingComponent: StepsSetting,
  }
}
